import { Validators } from "@angular/forms";
import { IFormKey } from "src/app/modules/shared/models/forms";
import * as moment from "moment";

export const debit_date_form_template = {
    variationDate: moment(),
    currentDebitDate: null,
    newDebitDate: null,
};

export const debit_date_form_validators = {
    variationDate: [Validators.required],
    currentDebitDate: [Validators.required],
    newDebitDate: [Validators.required]
};

export const debit_date_form_keys: IFormKey[] = [
    {
        id: 'variation-date-field',
        label: 'Data di variazione ',
        controlName: 'variationDate',
        css: 'col-3',
        type: 'DATEPICKER',
        minDate: moment()
    },
    {
        id: 'current-debit-date-field',
        label: 'Data di addebito Attuale',
        controlName: 'currentDebitDate',
        css: 'col-3',
        type: 'INPUT',
        readonly: true,
    },
    {
        id: 'new-debit-date-field',
        label: 'Data di addebito',
        controlName: 'newDebitDate',
        type: 'DATEPICKER',
        css: 'col-4'
    }
]